var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.38889 5.11111C6.38889 3.75556 6.92738 2.45553 7.8859 1.49701C8.84442 0.53849 10.1444 0 11.5 0C12.8556 0 14.1556 0.53849 15.1141 1.49701C16.0726 2.45553 16.6111 3.75556 16.6111 5.11111C16.6111 6.46666 16.0726 7.76669 15.1141 8.72521C14.1556 9.68373 12.8556 10.2222 11.5 10.2222C10.1444 10.2222 8.84442 9.68373 7.8859 8.72521C6.92738 7.76669 6.38889 6.46666 6.38889 5.11111ZM6.38889 12.7778C4.69445 12.7778 3.06941 13.4509 1.87126 14.649C0.673113 15.8472 0 17.4722 0 19.1667C0 20.1833 0.403868 21.1584 1.12276 21.8772C1.84165 22.5961 2.81667 23 3.83333 23H19.1667C20.1833 23 21.1584 22.5961 21.8772 21.8772C22.5961 21.1584 23 20.1833 23 19.1667C23 17.4722 22.3269 15.8472 21.1287 14.649C19.9306 13.4509 18.3055 12.7778 16.6111 12.7778H6.38889Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.141182aaa2525407797db42aa3e5f2cd.svg";
export { ForwardRef as ReactComponent };